import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <section className="min-h-[80vh] flex items-center justify-center px-6">
      <div className="text-center max-w-xl">
        <p className="overline-maroon mb-4">Error 404</p>
        <h1 className="font-serif-display font-light text-6xl md:text-8xl tracking-tight text-[#0F1E33]">
          Page <span className="italic text-[#1E3A5F]">not found</span>.
        </h1>
        <div className="mx-auto mt-6 w-24 hairline-gold" />
        <p className="mt-6 text-[#4A5A70] leading-relaxed">
          The page you were looking for may have moved or never existed. Let's
          take you back to the workshop floor.
        </p>
        <Link
          to="/"
          data-testid="notfound-home"
          className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-[#1E3A5F] text-[#D6E2F0] tracking-wide hover:bg-[#15273F] transition-colors"
        >
          <ArrowLeft size={18} weight="bold" />
          Back to Home
        </Link>
      </div>
    </section>
  );
}
